/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjects_Subject_Italian15Inputs */

const en__field__enum_teachingsubjects_subject_italian15 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_Italian15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italian`)
};

const de__field__enum_teachingsubjects_subject_italian15 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_Italian15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italienisch`)
};

/**
* | output |
* | --- |
* | "Italian" |
*
* @param {_Field__Enum_Teachingsubjects_Subject_Italian15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjects_subject_italian15 = /** @type {((inputs?: _Field__Enum_Teachingsubjects_Subject_Italian15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjects_Subject_Italian15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjects_subject_italian15(inputs)
	return de__field__enum_teachingsubjects_subject_italian15(inputs)
});
export { _field__enum_teachingsubjects_subject_italian15 as "_field__enum_teachingSubjects_SUBJECT_ITALIAN" }